import { FC } from "react";
import { TextField } from "@mui/material";
import ArrowDropUpOutlinedIcon from "@mui/icons-material/ArrowDropUpOutlined";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import { FilterTriggerComponentProps } from "@/components/common/select/dropdown-select/utils/types/filterTriggerComponentProps";
import { GroupingOptionIcon } from "@/components/pages/common/resource-explorer-grouping-selector-v2/components/GroupingOptionIcon";
import { XAxisGranularity } from "@/services/cloudchipr.api";

interface BillingExplorerXAxisSelectorTriggerProps
  extends FilterTriggerComponentProps {}

export const BillingExplorerXAxisSelectorTrigger: FC<
  BillingExplorerXAxisSelectorTriggerProps
> = ({ onClick, disabled, selectedValues, options, open }) => {
  const value = options.find((item) => item.value === selectedValues[0])
    ?.rawValue.label;

  return (
    <TextField
      size="xsmall"
      label="Granularity(X-Axis)"
      onClick={onClick}
      disabled={disabled}
      contentEditable={false}
      value={value}
      InputProps={{
        readOnly: true,
        inputProps: {
          style: {
            paddingLeft: 8,
            cursor: "pointer",
            caretColor: "transparent",
            textOverflow: "ellipsis",
            overflow: "hidden",
          },
        },
        sx: { pr: 1, cursor: "pointer", minWidth: 180 },
        startAdornment: (
          <GroupingOptionIcon
            grouping={selectedValues?.at(0) as XAxisGranularity}
          />
        ),
        endAdornment: open ? (
          <ArrowDropUpOutlinedIcon color="action" />
        ) : (
          <ArrowDropDownOutlinedIcon color="action" />
        ),
      }}
    />
  );
};
